<div id="content-wrapper">
  <div id="patients-list-wrapper">
    <ng-container *ngIf="!error && !isLoading && patientsList.length > 0; else innerLoading">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Patient</th>
            <th scope="col">Activités</th>
            <th scope="col" id="date-col">
              <button id="mark-all-read-button" type="button" class="btn btn-link" [disabled]="isLoading || isUpdating"
                (click)="markPatientsDiariesAsRead()">
                <ng-container *ngIf="isLoading || isUpdating; else markAllReadButton">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="visually-hidden">Chargement...</span>
                </ng-container>
                <ng-template #markAllReadButton>
                  <span class="desktop">Tous marquer comme lus</span>
                  <span class="mobile">Tous lus</span>
                </ng-template>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr msd-patient-diary-row *ngFor="let p of patientsList"
            [class.selected]="selectedPatient?.patientId?.equals(p.patientId)" [name]="p.fullName"
            [initials]="p.initials" [pictureUrl]="p.avatarUrl" [diaryCount]="p.unreadDiariesCount"
            [lastDiaryDate]="p.lastUnreadDiaryCreatedAt" (click)="selectPatient(p)"
            (onNameClick)="navigateToPatientRecord(p.id.toString())" click></tr>
        </tbody>
      </table>
    </ng-container>

    <ng-template #innerLoading>
      <ngx-inner-loading class="flex-center" [empty]="patientsList?.length === 0" [error]="!!error"
        [loading]="isLoading" (retry)="loadPatients()" [loadingDescription]="'Chargement...'"
        emptyDescription="Aucun patient" [errorDescription]="error" retryButtonText="Réessayer">
      </ngx-inner-loading>
    </ng-template>
  </div>

  <div *ngIf="selectedPatient" id="diary-wrapper">
    <msd-diary [patientId]="selectedPatient.id.toString()" period="day" [number]="2"
      [endDate]="selectedPatient.lastUnreadDiaryCreatedAt" [canBeEncouraged]="false"></msd-diary>
    <div id="diary-footer">
      <button id="mark-read-button" [disabled]="isLoading || isUpdating" type="button"
        (click)="markPatientDiariesAsRead(selectedPatient.id.toString())" class="btn btn-outline btn-outline-primary">
        <ng-container *ngIf="isLoading || isUpdating; else markReadButton">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #markReadButton>
          Marquer comme lu
        </ng-template>
      </button>
      <button *ngIf="selectedPatient.isAppInstalled" id="encouragment-button" type="button"
        class="btn btn-primary btn-gradient" (click)="onSendEncouragement()">
        Encourager
        <i i-bs name="send" width="12" height="12"></i>
      </button>
    </div>
  </div>
</div>
